import React from "react";
import classNames from "../../utils/classNames";

export interface RsCoreImageProps {
  /** Extra classes to control size/positioning (e.g. "h-6 w-auto", "mx-auto", etc.) */
  className?: string;
  /** Alt text for accessibility */
  alt?: string;
  /** Optional click handler */
  onClick?: () => void;
  /** Optional title tooltip */
  title?: string;
  /** If true, render as a block-level element */
  block?: boolean;
}

const RS_CORE_LOGO_SRC =
  "https://sawilmasharedstoragepuks.blob.core.windows.net/public/images/logos/rs/rs_core_logo.svg";

/**
 * RS Core logo image component.
 * Drop this anywhere you need the RS Core logo.
 */
export default function RsCoreImage({
  className,
  alt = "RS Core",
  onClick,
  title,
  block = false,
}: RsCoreImageProps) {
  return (
    <img
      src={RS_CORE_LOGO_SRC}
      alt={alt}
      title={title}
      onClick={onClick}
      className={classNames(
        block ? "block" : "inline-block",
        "select-none",
        // sensible default sizing; override with className as needed
        "h-7 w-auto",
        onClick ? "cursor-pointer" : "",
        className
      )}
      draggable={false}
      loading="lazy"
    />
  );
}
